import React from "react";

import { Image } from 'react-native'
import logo from './logo.png'
import { styles } from './styles'

export const LogoKansasCityChiefs: React.FC = () => (
  <Image resizeMode="contain" style={styles.image} source={{uri:logo}} />
);
